export default {"src":"/_next/static/media/TechnologyAnalysis.ef5cd0ba.svg","height":1186,"width":1094,"blurWidth":0,"blurHeight":0};